import Vue from 'vue'
import ToastComp from '@/components/Toast/index.vue'

let instance = null
let timer = null

function getInstance() {
  if (instance) return instance
  const ToastConstructor = Vue.extend(ToastComp)
  instance = new ToastConstructor({ el: document.createElement('div') })
  document.body.appendChild(instance.$el)
  return instance
}

/**
 * showToast({ title, message, icon, duration, mask, customIcon })
 * icon: 'success' | 'error' | 'warning' | 'fail' | 'loading' | 'none' | 'custom'
 * duration: ms; if icon === 'loading' and duration not provided, will not auto hide
 */
export function showToast(options = {}) {
  const ins = getInstance()
  const opts = Object.assign({ title: '', icon: 'none', duration: 1500, mask: false, customIcon: null }, options)

  // clear previous timer
  if (timer) {
    clearTimeout(timer)
    timer = null
  }

  ins.show({ title: opts.title, message: opts.title || opts.message, icon: opts.icon, mask: opts.mask, customIcon: opts.customIcon })

  // auto hide unless loading
  if (opts.icon !== 'loading') {
    if (opts.duration > 0) {
      timer = setTimeout(() => {
        ins.hide()
        timer = null
      }, opts.duration)
    }
  }

  return {
    hide: () => {
      if (timer) { clearTimeout(timer); timer = null }
      ins.hide()
    }
  }
}

export function hideToast() {
  if (!instance) return
  if (timer) { clearTimeout(timer); timer = null }
  instance.hide()
}

export default { showToast, hideToast }
